import { render } from "./SmallText.vue?vue&type=template&id=789ab4d1&scoped=true"
import script from "./SmallText.vue?vue&type=script&lang=js"
export * from "./SmallText.vue?vue&type=script&lang=js"

import "./SmallText.vue?vue&type=style&index=0&id=789ab4d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789ab4d1"]])

export default __exports__